import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {
  AddBeneficiaryUserDto,
  AddBusinessOperationsSupportDto,
  BeneficiaryUserApi,
  BusinessOperationsSupportUserApi,
} from 'Users/api/api';

const beneficiaryUserApi = new BeneficiaryUserApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const businessOperationsSupportUserApi = new BusinessOperationsSupportUserApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);

const addBeneficiariesUser = (beneficiaryUser: AddBeneficiaryUserDto) =>
  withCancellation(cancelToken =>
    beneficiaryUserApi.beneficiaryUserInsert('1', beneficiaryUser, getAxiosConfig(cancelToken))
  ).then(handleResponse);

const addBOSToolsUser = (bosToolsUser: AddBusinessOperationsSupportDto) =>
  withCancellation(cancelToken =>
    businessOperationsSupportUserApi.businessOperationsSupportUserInsert('1', bosToolsUser, getAxiosConfig(cancelToken))
  ).then(handleResponse);

export default {
  addBeneficiariesUser,
  addBOSToolsUser,
};
